<template>
    <div>
        <a href="#" @click="showModal()" class="caption caption-margins round-medium card">
            <div :class="backgroundPosition?'background-ovr':''" class="mobile-display" :style="loadMobileBg">
                <div class="caption-bottom">
                    <div class="caption-padding left-text">
                        <div class="slide_position">
                            <p class="award-title" >
                                {{title}}
                            </p>
                        </div>
                        <p class="award-desc">{{ description }}</p>
                    
                    </div>
                </div>
            </div>
            <div class="ipad-display" :style="loadTabletBg">
                <div class="caption-bottom">
                    <div class="caption-padding left-text">
                        <div class="slide_position">
                            <p class="award-title" v-if="loadModal=='national-awards-modal'">
                                NATIONAL
                                <br>
                                AWARDS
                            </p>
                            <p class="award-title" v-else-if="loadModal=='million-dollar-modal'">
                                MILLION
                                <br>
                                DOLLAR
                            </p>
                            <p class="award-title" v-else-if="loadModal=='2027-mdrt-modal'">
                                2027
                                <br>
                                MDRT
                            </p>
                            <p class="award-title" v-else>
                                {{title}}
                            </p>
                        </div>
                        <p class="award-desc">{{ description }}</p>
                        <!-- <p class="award-desc" v-if="loadModal=='2027-mdrt-modal'">
                            Eligibility : Personal Sales (open to All Ranks)
                        </p> -->
                    </div>
                </div>
            </div>
        </a>
        <AwardBannerModal
            :modal="passModal"
            :title="passTitle"
            :positionSliderMobile="passSliderMobile"
            :positionSliderIpad="passSliderIpad"
            :image="passImage"
            :overlapImage="passOverlapImage"
            :description="passDesc"
            :backgroundSizeMobile="passBgSizeMobile"
            :backgroundPosition="passBgPosition"
            :backgroundSizeIpad="passBgSizeIpad"
        />
    </div>
</template>
<style scoped>
.award-title{
    font-size: 48px !important;
    color: #ffffff;
    font-family: "HelveticaNeueLTStd-Bd";
    line-height: 45px;
}

.award-desc{
    font-size: 13px !important;
    color: #ffffff;
    font-family: "HelveticaNeue";
    line-height: revert;
}
.content {
    margin: 0px 0 20px 0 !important;
}
.caption-margins{
    margin: 0px 15px 20px 15px!important;
}
.caption-padding{
    padding:15px 20px 10px;
    background-image: linear-gradient(#00000000, #1f1f1f);
}
.caption-bottom p{
    padding-left: 3px;
    margin-bottom: 0;
    font-size: 9px;
}
@media (min-width: 500px){
    .background-ovr {
        background-size: auto !important;
    }
}

@media (max-width:765px){
    .award-title{
    font-size: 24px !important;
    line-height: 16px;
}
}
</style>
<script>
import AwardBannerModal from '@/components/AwardBannerModal.vue'
export default {
    name: 'AwardBanner',
    props: {
        modal: String,
        title: String,
        positionSliderMobile: String,
        positionSliderIpad: String,
        image: String,
        overlapImage: String,
        description: String,
        backgroundSizeMobile: String,
        backgroundSizeIpad: String,
        backgroundPosition: String
    },
    components: {
        AwardBannerModal
    },
    computed: {
        passModal(){
            return this.modal
        },
        passTitle(){
            return this.title
        },
        passSliderMobile(){
            return this.positionSliderMobile
        },
        passSliderIpad(){
            return this.positionSliderIpad
        },
        passImage(){
            return this.image
        },
        passOverlapImage(){
            return this.overlapImage
        },
        passDesc(){
            return this.description
        },
        passBgSizeMobile(){
            return this.backgroundSizeMobile
        },
        passBgSizeIpad(){
            return this.backgroundSizeIpad
        },
        passBgPosition(){
            return this.backgroundPosition
        },
        loadModal(){
            return this.modal
        },
        loadTitle(){
            return this.title
        },
        loadSliderMobile(){
            if(this.modal!='lifetime-partner-modal'){
                return {
                    'position': 'absolute',
                    'top': '15%',
                    'right': this.positionSliderMobile,
                    'width': '40px'
                }
            }
            else{
                return {
                    'position': 'absolute',
                    'right': this.positionSliderMobile,
                    'width': '40px'
                }
            }
        },
        loadSliderTablet(){
            if(this.modal=='lifetime-partner-modal'){
                return {
                    'position': 'absolute',
                    'left': '30%',
                    'top': '-10px'
                }
            }
            else if(this.modal=='national-awards-modal'){
                return {
                    'position': 'absolute',
                    'left': '260px'
                }
            }
            else if(this.modal=='million-dollar-modal'){
                return {
                    'position': 'absolute',
                    'left': '320px'
                }
            }
            else if(this.modal=='2027-mdrt-modal'){
                return {
                    'position': 'absolute',
                    'left': '220px'
                }
            }
            else {
                return {
                    'position': 'absolute',
                    'left': '30%'
                }
            }
        },
        loadOverlapMobileStyle(){
            return {
                'position': 'absolute',
                'top': '10px',
                'left': '0',
                'right': '0',
                'margin': '0 auto',
                'max-width': '174px'
            }
        },
        loadOverlapTabletStyle(){
            return {
                'position': 'absolute',
                'top': '10px',
                'right': '5%',
                'max-width': '300px'
            }
        },
        loadMobileBg(){
            if(this.backgroundPosition!=""){
                return {
                    'backgroundImage':'url(\'images/mpower-new/award_recognition/' + this.image + '\')',
                    'background-size': this.backgroundSizeMobile,
                    'background-repeat': 'no-repeat',
                    'background-position': this.backgroundPosition,
                    'height': '191px'
                }
            }
            else{
                return {
                    'backgroundImage':'url(\'images/mpower-new/award_recognition/' + this.image + '\')',
                    'background-size': this.backgroundSizeMobile,
                    'background-repeat': 'no-repeat',
                    'background-position': 'center',
                    'height': '191px'
                }
            }
        },
        loadTabletBg(){
            if(this.backgroundPosition!=""){
                return {
                    'backgroundImage':'url(\'images/mpower-new/award_recognition/iPad/' + this.image + '\')',
                    'background-size': this.backgroundSizeIpad,
                    'background-repeat': 'no-repeat',
                    'background-position': this.backgroundPosition,
                    'height': '191px'
                }
            }
            else{
                return {
                    'backgroundImage':'url(\'images/mpower-new/award_recognition/iPad/' + this.image + '\')',
                    'background-size': this.backgroundSizeIpad,
                    'background-repeat': 'no-repeat',
                    'background-position': 'center',
                    'height': '191px'
                }
            }
        },
        loadOverlapImage(){
            return this.overlapImage
        },
        loadDesc(){
            return this.description
        }
    },
    methods: {
      showModal() {
        document.querySelector(".header-s").style.display = "none";
        document.querySelector(".header").style.zIndex = "1";
        this.$modal.show(this.modal)
      },
      hideModal() {
        document.querySelector(".header-s").style.display = "block";
        document.querySelector(".header").style.zIndex = "96";
          this.$modal.hide(this.modal)
      },
    }
}
</script>
